import styled, { css } from 'styled-components';
import { Button as UiButton } from '@swordhealth/ui-corporate';
import NextImage from 'next/image';

export const Wrapper = styled.div`
  display: grid;
  gap: 32px;
  grid-template-columns: repeat(${(props) => props.$count}, 1fr);

  @media (max-width: ${(props) => props.theme.breakpoints.max_md}px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: ${(props) => props.theme.breakpoints.max_sm}px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

export const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 8px;

  img {
    object-fit: contain;
    object-position: left;
    width: auto;
  }
`;

export const Button = styled(UiButton)`
  @media (max-width: ${(props) => props.theme.breakpoints.max_md}px) {
    padding: 9px 24px;
    font-size: 14px;
    line-height: 20px;
  }
`;

export const ImageWrapper = styled.div`
  position: relative;
  align-content: center;
  @media (min-width: ${(props) => props.theme.breakpoints.min_md}px) and (max-width: ${(props) =>
      props.theme.breakpoints.max_md}px) {
    width: ${(props) => (props.$referralPick ? '50%' : '100%')};
  }
`;

export const Image = styled(NextImage)`
  position: relative;
  width: 100%;
  height: auto;

  border: 4px solid white;
  border-radius: 32px;
`;

export const Card = styled.div`
  display: flex;
  border-radius: 32px;
  width: 100%;
  background: ${(props) =>
    props.$referralPick
      ? 'linear-gradient(91.26deg, rgba(89, 147, 234, 0.8) 0.63%, rgba(255, 130, 131, 0.8) 98.97%)'
      : 'white'};
  cursor: pointer;
  position: relative;
  transition: all 0.3s ease;

  ${(props) =>
    props.$referralPick &&
    css`
      &::before {
        content: '';
        position: absolute;
        top: 25%;
        width: 100%;
        height: 50%;
        background: linear-gradient(
          100.52deg,
          rgba(89, 147, 234, 0.2) 0%,
          rgba(255, 131, 131, 0.2) 100%
        );
        filter: blur(40px);

        @media (min-width: ${(props) => props.theme.breakpoints.min_md}px) and (max-width: ${(
            props,
          ) => props.theme.breakpoints.max_md}px) {
          top: 0;
          left: 25%;
          width: 50%;
          height: calc(100% + 13px);
          background: linear-gradient(
            180deg,
            rgba(255, 131, 131, 0.16) 0%,
            rgba(89, 147, 234, 0.16) 100%
          );
        }
      }
    `}

  @media (max-width: ${(props) => props.theme.breakpoints.max_md}px) {
    grid-column: ${(props) => (props.$referralPick ? '1 / -1' : 'auto')};
  }

  p {
    color: #5c606b;
  }

  &:hover {
    background: #5993ea;
    & > div > div > button {
      background-color: var(--button-hover-bg);
      border-color: var(--button-hover-border);
      color: var(--button-hover-color);
    }
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
  z-index: 1;
`;

export const CardInner = styled.div`
  border-radius: 31px;
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  background: white;
  margin: 1px;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background: #eef4fd;
    opacity: 0;
    transition: opacity 0.3s ease;
    border-radius: 32px;
  }

  &:hover {
    &::before {
      opacity: 1;
    }
  }

  @media (min-width: ${(props) => props.theme.breakpoints.min_md}px) and (max-width: ${(props) =>
      props.theme.breakpoints.max_md}px) {
    flex-direction: ${({ $referralPick }) => ($referralPick ? 'row' : 'column')};
  }
`;

export const Content = styled.div`
  display: flex;
  gap: 16px;
  flex-direction: column;
  padding: 24px;
`;

export const ButtonWrapper = styled.div`
  padding: 0 24px 24px;
`;

export const Badge = styled.div`
  position: absolute;
  top: 12px;
  left: 12px;
  background: white;
  padding: 2px 10px;
  border-radius: 16px;
  z-index: 10;
  box-shadow: 0 2px 8px 0 #00000014;

  font-size: 14px;
  font-weight: var(--ui-font-weight-body-semibold);

  @media (min-width: ${(props) => props.theme.breakpoints.min_lg}px) {
    top: auto;
    left: auto;
    bottom: 0;
    right: 20px;
  }
`;

export const LogoBadge = styled.div`
  background-color: ${(props) => props.theme.colors.primary[50]};
  border-radius: 32px;
  padding: 5px 10px;
  color: ${(props) => props.theme.colors.primary[700]};
  font-weight: var(--ui-font-weight-body-semibold);
`;
